import React from "react"
import { useRouter } from "next/router"
import { RES_SUCCESS, FORM_SUCCESS_ROUTE, ERROR_MESSAGE } from "@constants/api"
import RequestQuote from "@components/form/forms/RequestQuote"
import { handleFormSubmission } from "@utils/api/quote"
import { RequestQuoteFormDataProps } from "@utils/api"

interface RequestQuoteFormProps {
  industries: Array<{
    industry: string
    email: string
  }>
  contactEmail: string
}

const RequestQuoteForm: React.FC<RequestQuoteFormProps> = ({
  industries,
  contactEmail,
}) => {
  const [errorState, setErrorState] = React.useState(false)
  const [isFetchingData, setIsFetchingData] = React.useState(false)
  const router = useRouter()

  const onFormSubmit = async (data: RequestQuoteFormDataProps) => {
    setIsFetchingData(true)
    const industryContact = industries.find(
      ({ industry }) => industry === data.industry
    )

    const cleanContactEmail = (contactEmail: string) => {
      const validateEmail = (email) => {
        return String(email)
          .toLowerCase()
          .match(/\S+@\S+\.\S+/)
      }
      let results: string[] = contactEmail
        .replace(" ", "")
        .split(",")
        .reduce((results: string[], email: string) => {
          if (validateEmail(email)) {
            results.push(email)
          }
          return results
        }, [])
      return results
    }

    const res: any = await handleFormSubmission(
      data,
      (industryContact?.email && cleanContactEmail(industryContact.email)) || [
        contactEmail,
      ]
    )
    setIsFetchingData(false)
    if (res.status === RES_SUCCESS) {
      router.push(FORM_SUCCESS_ROUTE)
    } else {
      setErrorState(true)
    }
  }

  return (
    <RequestQuote
      industries={industries}
      onSubmit={(data: RequestQuoteFormDataProps) => onFormSubmit(data)}
      errorMessage={errorState ? ERROR_MESSAGE : undefined}
      isLoading={isFetchingData}
    />
  )
}

export default RequestQuoteForm
